import { render } from "./Feedbacks.vue?vue&type=template&id=5542bd88&scoped=true"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"

import "./Feedbacks.vue?vue&type=style&index=0&id=5542bd88&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5542bd88"]])

export default __exports__